'use client'

export default function LandingBlockIWantToTry(props: any) {
    return (
        <div style={{maxWidth: 600}} className={"px-4 lg:px-0"}>
            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                <span className={"text-4xl font-semibold"}>I want to try it! 😻</span>
                <div className={"border-b border-b-fuchsia-400 w-10 md:w-20 lg:w-96 my-7"}></div>
            </div>
            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                The Bullish Trade is available <span className={"font-bold"}>for free</span>.
            </div>
            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                Free for 3 searches per day.
                <div className={"text-sm text-gray-500 mt-2"}>
                    You get tens of trade ideas just from one search! And with three?
                    <br/>
                    You will definitely find something awesome!
                </div>
            </div>
            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                Signup, select your favourite companies
            </div>
            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                And see if there are any nice trades at this moment 💸
            </div>
        </div>
    )
}
